export default __webpack_public_path__ + "assets/calendar-3b0dde8e03037933b1e1a9141279fe63.svg";